<template>
         <!-- height: calc(100% - 380px); -->

    <div class="order" :class="{
            order_freightHeight: !(
                !freightData.hasSpecialFreight && freightData.freight === null
            )&&isShowFreight,
        }"
    >

        <Head :headInfo="headInfo" @onClickLeft="onBack" />
        <div class="order_common order_model">
            <div class="order_model_left">配送方式</div>
            <div class="order_model_right order_arrow" @click="onOpen('model')">
                {{ modelAddress[addressIndex].name }}
                <van-icon name="arrow" />
            </div>
        </div>
        <div class="order_borderTop" v-if="modelAddress[addressIndex].type === 1" @click="onOpen('address')">
            <AddressTemplate :addressInfo="addressInfo" />
        </div>
        <div class="order_group" v-for="(item, index) in shopInfo" :key="item.id">
            <div class="order_borderBottom" v-if="modelAddress[addressIndex].type === 2" @click="onOpen('pick', index, item.merchantCode)">
                <AddressTemplate :addressInfo="pickAddress[index]" />
            </div>
            <div class="order_group_title">
                <i class="iconfont iconicon_dianpu"></i>
                <span>{{ item.shopName }}</span>
            </div>
            <div class="order_group_goodList">
                <GoodTemplate v-for="it in item.skus" :key="it.id" :sku="it" :presaleId="presaleId" />
            </div>
            <div class="order_common order_model order_f32" @click="onOpen('coupon', index)" v-if="accountShow && !tyingId">
                <div class="order_model_left">优惠券</div>
                <div class="order_model_right order_colFF7A45 order_arrow" v-if="
                        item.optimalCouponCompose &&
                        sumCouponPrice(item.optimalCouponCompose)
                    ">
                    已优惠 ¥{{
                        sumCouponPrice(item.optimalCouponCompose) | NumFormat
                    }}
                    <van-icon name="arrow" />
                </div>
                <div class="order_model_right order_colFF7A45 order_arrow" v-else>
                    <span>不使用优惠券</span>
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="order_common order_model order_f32" v-if="item.shopActivity">
                <div class="order_model_left">促销活动</div>
                <div class="order_model_right order_colFF7A45 order_arrow">
                    已优惠 ¥{{
                        Math.abs(item.shopActivity.discountAmount) | NumFormat
                    }}
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="order_common order_model order_f32" @click="onOpen('full', index)" v-if="item.rebateDeduction">
                <div class="order_model_left">满返抵扣</div>
                <div class="order_model_right order_colFF7A45 order_arrow" v-if="item.rebatePrice && item.rebateShow">
                    已优惠 ¥{{
                        item.rebatePrice | NumFormat
                    }}
                    <van-icon name="arrow" />
                </div>
                <div class="order_model_right order_colFF7A45 order_arrow" v-else>
                    <span>不使用</span>
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="order_common order_model order_f32" v-if="tyingPrice">
                <div class="order_model_left">优惠金额</div>
                <div class="order_model_right order_colFF7A45 order_arrow">
                    已优惠 ¥{{ Math.abs(tyingPrice) | NumFormat
                    }}
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="" v-if="presaleId">
                <Step :stepInfo="stepInfo" :downShow="true" @onChecked="onChecked" />
            </div>
            <div class="order_common order_f32">
                <div class="order_remark_title">订单备注</div>
                <div class="order_remark_textarea">
                    <textarea rows="3" maxlength="100" v-model="item.remark" placeholder="未填写"></textarea>
                    <span>100个字</span>
                </div>
            </div>
            <div class="order_common order_f32 order_borderBottom">
                <div class="order_update_title">
                    上传附件<span>(最多8张)</span>
                </div>
                <div class="order_update_textarea">
                    <div class="order_update_textarea_img" v-for="(it, idx) in item.orderAnnexes" :key="idx">
                        <span @click="closeImg(index, idx)" class="order_update_textarea_close"></span>
                        <img :src="it.annexUrl" alt="" />
                    </div>
                    <div class="order_update_textarea_img" @click="onPic('orderPic', item, index)" v-if="item.orderAnnexes.length < 8">
                        <img src="../../../assets/img/b2b/image_add@2x.png" alt="" />
                    </div>
                </div>
            </div>
            <div class="order_group_foot">
                共{{ oneNum(item.skus) }}件 合计：
                <span class="order_colFF7A45">
                    <sub>¥</sub>
                    {{
                        onePrice(
                            item.shopActivity,
                            item.optimalCouponCompose,
                            item
                        ) | NumFormat
                    }}
                </span>
            </div>
        </div>
        <div class="order_height" v-if="payModelList[paymentIndex].type === 1"></div>
        <div class="order_footer">
            <div class="order_common order_model order_borderBottom">
                <div class="order_model_left">支付方式</div>
                <div class="order_model_right order_arrow" @click="onOpen('pay')">
                    {{ payModelList[paymentIndex].payName }}
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="order_common order_freight order_borderBottom"
                v-if="!(!freightData.hasSpecialFreight && freightData.freight === null) && isShowFreight "
            >
                <p>
                    <span>商品总计</span>
                    <span>￥{{ totalPrice() | NumFormat }}</span>
                </p>
                <p @click="onOpen('fright')">
                    <span>运费总计</span>
                    <span class="order_freight_price" v-if="!freightData.hasSpecialFreight">
                        ￥{{ freightData.freight | NumFormat }}
                        <van-icon name="arrow" v-if="freightData.freight!==null" />
                    </span>
                    <span class="order_freight_price order_colFF7A45" v-else>待运营维护
                        <van-icon name="arrow" />
                    </span>
                </p>
                <p v-if="payModelList[paymentIndex].type === 1" class="accountpayment">
                    <span>
                        账期支付 (可用额度 ¥{{
                            termsInfo.remainingAmount | NumFormat
                        }})
                    </span>
                    <span class="order_colFF7A45" v-if="termsInfo.remainingAmount - totalPrice() - (freightData.freight||0) >= 0">
                        ¥{{(totalPrice() + freightData.freight) | NumFormat }}
                    </span>
                    <span class="order_colFF7A45" v-else>额度不足</span>
                </p>
            </div>
            <div class="order_footer_sum">
                <div class="order_footer_sum_left">
                    <div v-if="payModelList[paymentIndex].type !== 1">
                        合计<span v-show="
                                !(
                                    !freightData.hasSpecialFreight &&
                                    freightData.freight === null
                                ) && isShowFreight
                            " class="order_freight_color">(含运费)</span>
                        ：<span class="order_colFF7A45" v-if="!freightData.hasSpecialFreight">
                            <sub>¥</sub>
                            {{
                                (totalPrice() + freightData.freight) | NumFormat
                            }}
                        </span>
                        <span class="order_colFF7A45" v-else>待运营维护</span>
                    </div>
                </div>
                <div class="order_footer_sum_right" @click="submitOrder">
                    提交订单
                </div>
            </div>
        </div>
        <PopupPayMent :visible.sync="popupPay" v-if="payModelList.length" :payModelList="payModelList" @getPayment="getPayment" />
        <PopupFull :visibleFull.sync='popupFullShow' :rebatePrice='rebatePrice' @onFull='onFull' />
        <PopupApprove :visible.sync="popupApprove"></PopupApprove>
        <StopPopup :visible.sync="popupStop"></StopPopup>
        <DeliveryModel :visible.sync="popupModel" v-if="popupModel" :modelAddress="modelAddress" @payModel="payModel" />
        <SelectCoupon :visible.sync="popupCoupon" v-if="popupCoupon" :couponInfo="couponInfo" @getCouponList="getCouponList" @getFreight='getFreightInfo' />
        <SelectServer :visible.sync="popupServer" v-if="popupServer" @freightSubmit="freightSubmit" />
        <SelectFreight :visible.sync="popupFreight" :freightInfo="freightData" v-if="popupFreight" />
        <SelectAddress :visible="popupAddress" ref="address" v-if="popupAddress" :addressInfo="addressInfo" @onShow="popupAddress = false" @getAddress="getAddress" />
        <PickAddress :visible.sync="popupPick" v-if="popupPick" :pickAddress="pickAddress[pickIndex]" :pickCode="pickCode" @getPickAddress="getPickAddress" />
    </div>
</template>
<script>
import Head from '../../common/head'
import GoodTemplate from './component/goodTemplate' // 商品列表
import AddressTemplate from './component/addressTemplate' // 地址
import PopupPayMent from '../common/popupPayment' // 支付方式
import PopupApprove from '../common/approvePopup' // 是否认证
import StopPopup from '../common/stopPopup' // 是否禁止
import DeliveryModel from '../common/deliveryModel' // 配送地址
import SelectCoupon from './component/selectCoupon' // 选择优惠券
import SelectAddress from './component/selectAddress' // 选择地址
import PickAddress from './component/pickAddress' // 自提地址
import Step from '../common/step' // 预售流程步骤
import SelectServer from './component/selectServer' // 运费服务说明弹窗
import SelectFreight from './component/selectFreight' // 运费明细列表
import PopupFull from './component/popupFull' // 满返折扣弹窗
import { versions } from '../../common/version' // 判断内核为ios还是安卓
import { getDefaultAddress, depotAddress } from '../api/address'
import { getIsTerm, getTermInfo } from '../api/product'
import { getSubmitOrder, setSubmitOrder, getFreight } from '../api/order'
import { Dialog, Toast } from 'vant'
import { mapActions } from 'vuex'
// import { versions } from '../../common/version'
import { clearCache, newCache } from '@/utils/index'
import NP from 'number-precision'
export default {
    name: 'confirmOrder',
    components: {
        Head,
        GoodTemplate,
        AddressTemplate,
        PopupPayMent,
        PopupApprove,
        StopPopup,
        DeliveryModel,
        SelectCoupon,
        SelectAddress,
        PickAddress,
        Step,
        SelectServer,
        SelectFreight,
        PopupFull
    },
    beforeRouteEnter (to, from, next) {
        newCache('confirmOrder')
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (!(to.name === 'addAddress' || to.name === 'editAddress')) {
            clearCache('confirmOrder')
        }
        next()
    },
    data () {
        return {
            headInfo: {
                title: '确认订单'
            },
            userInfo: null, // 用户基本信息
            shopInfo: [], // 店铺信息数据
            orderType: 0, // 0: 普通订单 1：组合订单
            isTherm: false, // 是否显示账期支付
            addressIndex: 0, // 配送方式的Index
            paymentIndex: 0, // 支付方式的Index
            modelAddress: [{ type: 1, name: '送货上门' }, { type: 2, name: '自提' }], // 配送方式
            payModelList: [ // 支付方式
                { type: 4, payName: '在线支付' },
                { type: 2, payName: '企业转账' }
            ],
            stepInfo: [ // 预售内容
                { title: '支付定金', content: '待付定金 ¥0.00', downColor: true, contentColor: true },
                { title: '支付尾款', content: '02月22日 00:00:01 开始开始支付尾款', downColor: false, contentColor: false }
            ],
            reserveAmount: 0, // 预售金额
            checked: true, // 预售协议勾选
            popupModel: false, // 是否配送方式
            popupPay: false, // 是否支付方式
            popupApprove: false, // 是否显示认证
            popupStop: false, // 是否显示禁止
            popupCoupon: false, // 是否显示选择优惠券列表
            popupAddress: false, // 是否显示选择地址
            popupPick: false, // 是否显示自提地址
            popupServer: false, // 是否显示运费说明弹窗
            orderAnnexes: [], // 报备信息
            shopIndex: 0, // 店铺索引
            addressInfo: {}, // 送货上面地址信息
            couponInfo: null, // 选中的优惠券
            pickAddress: [], // 选中的自提地址
            isPick: false, // 是否显示自提
            pickIndex: 0, // 自提地址索引
            pickCode: '', // 自提地址merchantCode
            depotAddressList: [], // 仓库地址列表
            accountShow: true, // 优惠商品的一些内容从显示
            isCoupon: true, // 优惠券的二次弹窗判断
            popupFreight: false, // 运费明细显示
            payModelShow: false, // 是否显示其他支付方式
            addressMemberCode: 'f47596433af5f4e60d7a3a1732407aee', // 禁用code
            popupFullShow: false,
            freightData: {
                freight: 0,
                hasSpecialFreight: false,
                skuFreightDetailList: [],
                firstFreightOrder: false
            },
            activityDataInfo: {
                activityId: '',
                discountAmount: 0
            }, // 促销活动信息
            termsInfo: {
                amount: 0,
                locked: false,
                overdue: true,
                remainingAmount: 0
            }, // 账期信息
            rebatePrice: 0, // 满返折扣
            couponDataInfo: [], // 优惠券信息
            orderDiscountList: [], // 活动，优惠券和组合go的数据
            couponDiscountList: [], // 优惠券传递数据的存储
            tyingPrice: 0, // 组合go价格
            activityParams: {}, // 特价传递的埋点数据
            spikeId: this.$route.query.spikeId, // 特价的id
            presaleId: this.$route.query.presaleId, // 预售的id
            groupId: this.$route.query.groupId, // 拼团的id
            goodsId: this.$route.query.goodsId, // 商品的id
            inquiryId: this.$route.query.inquiryId, // 询价的id
            tyingId: this.$route.query.tyingId, // 组合goid
            themeActivityId: this.$route.query.themeActivityId, // 辅材一件购
            groupParticipationId: this.$route.query.groupParticipationId // 拼团记录id
        }
    },
    computed: {
        isShowFreight () {
            return !(this.spikeId || this.tyingId || this.groupId || this.presaleId)
        }
    },
    methods: {
        ...mapActions(['setBuried', 'setActivity']),
        onBack () {
            this.$router.back()
        },
        // 底部的popup弹出
        onOpen (obj, index, merchantCode) {
            switch (obj) {
                case 'model':
                    if (this.modelAddress.length === 1) {
                        return
                    }
                    this.popupModel = !this.popupModel
                    break
                case 'pay':
                    if (this.payModelList.length === 1) {
                        return
                    }
                    if (!this.orderType && this.userInfo.isCommodity && this.userInfo.isOperational) {
                        this.popupPay = !this.popupPay
                    }
                    break
                case 'address':
                    this.popupAddress = !this.popupAddress
                    break
                case 'full':
                    this.pickIndex = index
                    let rebate = this.getTotalMoeny(this.shopInfo[index].shopActivity, this.shopInfo[index].optimalCouponCompose, this.shopInfo[index])
                    if (rebate.rebatePrice) {
                        this.rebatePrice = rebate.rebatePrice
                    } else if (rebate.rebateTotalPrice > rebate.money) {
                        this.rebatePrice = rebate.money
                    } else {
                        this.rebatePrice = rebate.rebateTotalPrice
                    }
                    if (this.rebatePrice) {
                        this.popupFullShow = !this.popupFullShow
                    } else {
                        Toast('订单优惠后金额已无需抵扣！')
                    }
                    break
                case 'coupon':
                    this.buryPoint(67)
                    // 对优惠券的信息进行处理，进行传递
                    this.shopIndex = index
                    let oneShop = this.shopInfo[index]
                    let oneActivity = oneShop.shopActivity ? oneShop.shopActivity : { discountAmount: 0, activityId: '' }
                    let oneCoupon = oneShop.optimalCouponCompose ? oneShop.optimalCouponCompose : { discount: 0, coupons: [] }
                    let coupon = {
                        merchantCode: oneShop.merchantCode,
                        productList: oneShop.skus,
                        totalAmount: (oneShop.finalTotalAmount - oneActivity.discountAmount).toFixed(2),
                        activityId: oneActivity.activityId,
                        couponArr: oneCoupon.coupons
                    }
                    this.couponInfo = coupon
                    this.popupCoupon = !this.popupCoupon
                    break
                case 'pick':
                    this.pickIndex = index
                    this.pickCode = merchantCode
                    this.popupPick = !this.popupPick
                    break
                case 'fright':
                    if (!(!this.freightData.hasSpecialFreight && this.freightData.freight === null)) {
                        this.popupFreight = !this.popupFreight
                    }
                    break
                default:
                    break
            }
        },
        // 获取满返折扣的选择
        onFull (val) {
            if (val === '1') {
                this.shopInfo[this.pickIndex].rebateShow = true
                this.shopInfo[this.pickIndex].rebatePrice = this.rebatePrice
            } else {
                this.shopInfo[this.pickIndex].rebateShow = false
                this.shopInfo[this.pickIndex].rebatePrice = 0
            }
            this.popupFullShow = !this.popupFullShow
            this.getFreightInfo()
            this.$forceUpdate()
        },
        // 总共商品合计金额
        totalPrice () {
            if (this.presaleId) {
                return this.reserveAmount
            }
            let price = this.shopInfo.reduce((sum, num) => {
                return sum + num.onePrice
            }, 0)
            let totalPrice = price
            return totalPrice >= 0 ? totalPrice : 0
        },
        // 计算店铺的优惠券金额
        sumCouponPrice (data) {
            if (!data.coupons.length) {
                return 0
            }
            let price = data.coupons.reduce((sum, num) => {
                return sum + num.actualDiscount
            }, 0)
            return price
        },
        // 店铺的合计金额
        onePrice (activityInfo, couponInfo, shop) {
            if (this.presaleId) {
                return this.reserveAmount
            }
            let rebate = this.getTotalMoeny(activityInfo, couponInfo, shop)
            shop.rebatePrice = rebate.rebatePrice
            let money = rebate.money - shop.rebatePrice
            let moneyNum = money > 0 ? money : 0
            shop.onePrice = moneyNum
            return moneyNum
        },
        // 用于店铺金额的计算
        getTotalMoeny (activityInfo, couponInfo, shop) {
            let activityPrice = activityInfo ? activityInfo.discountAmount : 0
            let couponPrice = couponInfo ? this.sumCouponPrice(couponInfo) : 0
            let money = shop.totalAmount - activityPrice - couponPrice - this.tyingPrice
            let rebatePrice = 0
            if (shop.rebateTotalPrice > money && shop.rebateShow) {
                rebatePrice = money
            } else if (shop.rebateTotalPrice < money && shop.rebateShow) {
                rebatePrice = shop.rebateTotalPrice
            } else {
                rebatePrice = shop.rebatePrice
            }
            return { money, rebatePrice, rebateTotalPrice: shop.rebateTotalPrice }
        },
        // 店铺的合计数量
        oneNum (item) {
            let num = 0
            for (let i = 0; i < item.length; i++) {
                num += item[i].quantity
            }
            return num
        },
        // 获取送货上门地址
        getAddress (item) {
            this.popupAddress = false
            this.addressInfo = item
            this.getFreightInfo()
        },
        // 预售协议是否选中
        onChecked (val) {
            this.checked = val
        },
        // 获取支付方式
        getPayment (paymentIndex) {
            this.paymentIndex = paymentIndex
        },
        // 获取配送方式
        payModel (index) {
            this.addressIndex = index
            // 进行埋点
            if (this.modelAddress[this.addressIndex].type === 2) {
                // 自提不使用运费
                this.freightData = {
                    freight: 0,
                    hasSpecialFreight: false,
                    skuFreightDetailList: [],
                    firstFreightOrder: false
                }
                this.buryPoint(25)
            } else {
                this.getFreightInfo()
                this.buryPoint(26)
            }
        },
        // 获取选中优惠券
        getCouponList (obj) {
            // 获取优惠券的信息
            this.shopInfo[this.shopIndex].optimalCouponCompose.coupons = obj.checkCouponData
            // 优惠券列表入参信息
            this.couponInfo = obj.item
            // 用于更新满返折扣的值
            let rebate = this.getTotalMoeny(this.shopInfo[this.shopIndex].shopActivity, this.shopInfo[this.shopIndex].optimalCouponCompose, this.shopInfo[this.shopIndex])
            this.shopInfo[this.shopIndex].rebatePrice = rebate.rebatePrice
            this.$forceUpdate()
        },
        // 获取自提的地址
        getPickAddress (item) {
            this.pickAddress[this.pickIndex] = item
        },
        // 判断是否调用活动或者优惠券的接口
        getType () {
            // 判断是否为商品运营型商家
            // let typeBoolean = this.userInfo.isCommodity && this.userInfo.isOperational ? 'true' : 'false'
            /**
             * orderType: 0: 普通订单 1：组合订单
             * inquiryId: 询价id
             * tyingId: 组合id
             * spikeId: 特价id
             * groupId: 拼团id
             * presaleId: 预售id
            */
            if (this.tyingId) {
                // 获取组合go的优惠信息
                let discountsArr = this.shopInfo[0].orderAdjustments
                let tyingDisCount = discountsArr.map(item => {
                    if (item.sourceType === 2) {
                        return item
                    }
                })
                this.tyingPrice = Math.abs(tyingDisCount[0]['amount'])
            }
        },
        // 获取原生传递的图片url
        getOEImgUrl (tag, url) {
            this.shopInfo[this.shopIndex].orderAnnexes.push({ 'annexType': 1, 'annexUrl': url, 'url': url })
            this.$forceUpdate()
        },
        // 调用原生的图片上传
        onPic (target, item, index) {
            if (item.orderAnnexes.length >= 8) {
                return false
            }
            this.shopIndex = index
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callPhoto',
                    'target': target
                })
            } else {
                window.kfxt.callPhoto(target)
            }
        },
        // 删除图片
        closeImg (pickIndex, index) {
            this.shopInfo[pickIndex].orderAnnexes.splice(index, 1)
            this.$forceUpdate()
        },
        // 获取店铺信息
        async getStopInfo () {
            let formData = {
                merchantCode: this.userInfo.belongMerchantCode,
                memberCode: this.userInfo.companyCode,
                shops: JSON.parse(localStorage.getItem('goodsData'))
            }
            Toast.loading({
                message: '数据加载中...',
                duration: 0,
                forbidClick: true
            })
            const { data } = await getSubmitOrder(formData)
            Toast.clear()
            this.orderType = data.orderType
            this.shopInfo = data.shops
            this.shopInfo.forEach(item => {
                item.rebateTotalPrice = item.rebatePrice = item.rebateDeduction ? item.rebateDeduction.amount : 0
                item.rebateShow = true
                item.remark = ''
                item.orderAnnexes = []
            })
            this.getAddressInfo() // 默认地址
            this.getType() // 逻辑判断
            // 预售步骤信息内容展示
            if (this.presaleId) {
                this.reserveAmount = this.shopInfo[0].reserveAmount
                let date = this.shopInfo[0].retainageStartTime
                date = this.toTime(date)
                let d = new Date(date)
                this.stepInfo[0]['content'] = '待付定金 ¥' + this.shopInfo[0].reserveAmount
                this.stepInfo[1]['content'] = (d.getMonth() + 1) + '月' + d.getDate() + '日 ' + this.num(d.getHours()) + ':' + this.num(d.getMinutes()) + ':' + this.num(d.getSeconds()) + '开始支付尾款'
            }
            // 代采商品必须在线支付（可使用优惠券）
            if (data.hasAgentSku) {
                this.modelAddress = [{ type: 1, name: '送货上门' }]
                this.payModelList = [{ type: 4, payName: '在线支付' }]
                this.accountShow = true // 控制一些内容的显示
            }
            // 特价-拼团-预售不使用自提，活动，优惠券，账期
            if (this.spikeId || this.groupId || this.presaleId) {
                this.modelAddress = [{ type: 1, name: '送货上门' }]
                this.payModelList = [{ type: 4, payName: '在线支付' }]
                this.accountShow = false // 控制一些内容的显示
                return
            }

            let shopArrShow = this.shopInfo.map(item => item.merchantCode)
            // 针对特定用户进行处理
            if (shopArrShow.indexOf(this.addressMemberCode) >= 0) {
                this.payModelList = [{ type: 4, payName: '在线支付' }]
            }
            this.isPickAddress() // 是否显示自提地址
            if (!data.hasAgentSku && !data.orderType && shopArrShow.indexOf(this.addressMemberCode) < 0) {
                // 是否支持账期接口
                this.getIsPayMent()
            }
            if (!this.isPick) {
                // 自提地址的结构
                this.pickAddress = JSON.parse(JSON.stringify(data.shops)).fill({})
            }
        },
        // 处理ios多8小时的问题
        toTime (strTime) {
            if (!strTime) {
                return ''
            }
            var myDate = new Date(strTime + '+0800')
            if (myDate == 'Invalid Date') {
                strTime = strTime.replace(/T/g, ' ') // 去掉T
                strTime = strTime.replace(/-/g, '/')
                strTime = strTime.replace(/\.\d+/, ' ') // 去掉毫秒
                myDate = new Date(strTime + '+0800')
            }
            return myDate
        },
        // 对日期个位补0
        num (n) {
            return n < 10 ? '0' + n : '' + n
        },
        // 是否显示自提地址
        async isPickAddress () {
            await Promise.all(this.shopInfo.map(item => this.getDepotAddress(item.merchantCode))).then(() => {
                if (this.depotAddressList.indexOf(0) >= 0) {
                    this.modelAddress = [{ type: 1, name: '送货上门' }]
                    this.isPick = true
                }
            })
        },
        // 获取是否支持账期
        async getIsPayMent () {
            let shopArr = this.shopInfo[0].skus.map(item => {
                return {
                    brandId: item.brandId,
                    skuId: item.skuId
                }
            })
            const { data } = await getIsTerm({
                merchantCode: this.userInfo.belongMerchantCode,
                memberCode: this.userInfo.companyCode,
                skuList: shopArr
            })
            if (data) {
                this.getPayMentInfo()
            }
        },
        // 获取账期信息
        async getPayMentInfo () {
            const { data } = await getTermInfo({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            })
            this.termsInfo = data
            let isTherm = data.amount && !data.locked
            if (!isTherm) {
                this.payModelList = [
                    { type: 4, payName: '在线支付' },
                    { type: 2, payName: '企业转账' }
                ]
            } else {
                this.payModelList = [
                    { type: 4, payName: '在线支付' },
                    { type: 1, payName: '账期支付' },
                    { type: 2, payName: '企业转账' }
                ]
            }
        },
        // 获取仓库地址
        async getDepotAddress (merchantCode) {
            const { data } = await depotAddress({
                merchantCode: merchantCode
            })
            this.depotAddressList.push(data.length)
        },
        // 获取默认地址
        async getAddressInfo () {
            Toast.loading({
                message: '数据加载中...',
                duration: 0,
                forbidClick: true
            })
            const { data } = await getDefaultAddress({
                memberCode: this.userInfo.companyCode
            })
            Toast.clear()
            if (data) {
                this.addressInfo = data
                this.$nextTick(() => {
                    this.getFreightInfo()
                })
            }
        },
        async getFreightInfo () {
            this.$nextTick(async () => {
                if (this.spikeId || this.tyingId || this.groupId || this.presaleId) {
                    return
                }
                let address = this.addressInfo
                if (!Object.keys(address).length) {
                    return false
                }
                console.log('log:::::: this.shopInfo', JSON.stringify(this.shopInfo))
                let orderAmount = ''
                let skuList = this.shopInfo.map(item => {
                    orderAmount = NP.plus(orderAmount, item.onePrice)
                    let skuArr = item.skus
                    let sku = skuArr.map(it => {
                        return {
                            price: it.price,
                            merchantCode: item.merchantCode,
                            skuId: it.skuId,
                            quantity: it.quantity,
                            skuName: it.skuName,
                            skuImageUrl: it.pictureUrl,
                            skuCode: it.skuCode,
                            model: it.model
                        }
                    })
                    return sku
                })
                let params = {
                    orderAmount: this.totalPrice(),
                    memberCode: this.userInfo.companyCode,
                    memberAddressId: address.id,
                    shippingMethod: this.modelAddress[this.addressIndex].type,
                    skuList: skuList.flat(Infinity)
                }
                const { data } = await getFreight(params)
                if (data.skuFreightDetailList) {
                    data.skuFreightDetailList.forEach(item => {
                        let res = skuList.flat(Infinity).find(sku => sku.skuId == item.skuId)
                        if (res) {
                            item.price = res.price
                        }
                    })
                }
                this.paymentIndex = 0
                // if (!(!data.hasSpecialFreight && !data.freight)) {
                //     this.payModelShow = true
                // }
                this.freightData = {
                    freight: data.actualAmount, // 实际运费金额
                    discountAmount: data.discountAmount, // 运费优惠金额
                    totalAmount: data.totalAmount, // 运费合计金额
                    hasSpecialFreight: data.hasSpecialFreight, // sku运费明细
                    skuFreightDetailList: data.skuFreightDetailList || [],
                    firstFreightOrder: data.firstFreightOrder // 是否首个运费订单
                }
                console.log('🚀 --- getFreightInfo --- this.freightData', this.freightData)
            })
        },
        // 提交订单校验
        getStatus () {
            if (!this.shopInfo.length) {
                Toast({
                    message: '很抱歉，您购买的商品不存在',
                    forbidClick: true
                })
                return false
            }
            // 是否禁用
            if (!this.userInfo.isEnabled) {
                this.popupStop = true
                return false
            }
            this.buryPoint(24)
            if (this.modelAddress[this.addressIndex].type === 1) {
                if (!this.addressInfo.id) {
                    Toast({
                        message: '请选择收货地址',
                        forbidClick: true
                    })
                    return false
                }
            } else {
                let pickAddress = this.pickAddress.filter(item => item.name)
                if (this.shopInfo.length !== pickAddress.length) {
                    Toast({
                        message: '请选择相对应的地址',
                        forbidClick: true
                    })
                    return false
                }
            }
            if ((this.payModelList[this.paymentIndex].type === 1) && ((this.termsInfo.remainingAmount - this.totalPrice() - this.freightData.freight) < 0)) {
                Toast({
                    message: '账期额度不足，请更换支付方式',
                    forbidClick: true
                })
                return false
            }
            if (this.themeActivityId) {
                console.log(this.shopInfo)
                let productArr = []
                this.shopInfo.forEach(i => {
                    i.skus.forEach(item => {
                        productArr.push({
                            spu_code: item.spuCode,
                            spu_id: item.spuId,
                            spu_name: item.spuName,
                            sku_price: item.price,
                            sku_quantity: item.quantity,
                            sku_id: item.skuId,
                            sku_code: item.skuCode,
                            sku_name: item.skuName
                        })
                    })
                })
                console.log(productArr)
                this.getPoint(70, {
                    skuList: productArr
                })
            }
            // 提示优惠券的实际优惠金额与面额的大小
            if (this.isCoupon && this.couponDataInfo.length) {
                let couponValue = 0 // 优惠券的总面额
                let actualDiscount = 0 // 优惠券的实际优惠金额
                this.couponDataInfo.forEach(item => {
                    couponValue += item.couponValue
                    actualDiscount += item.actualDiscount
                })
                if (actualDiscount < couponValue) {
                    Dialog.confirm({
                        title: '提示',
                        message: '当前有优惠券超额，请确认',
                        confirmButtonColor: '#FF7A45'
                    }).then(() => {
                        this.isCoupon = false
                        this.submitOrder()
                    }).catch(() => {
                    })
                    return false
                }
            }
            if (!this.checked) {
                Toast({
                    message: '请阅读并勾选同意协议，否则无法提交订单',
                    forbidClick: true
                })
                return false
            }
            return true
        },
        freightSubmit () {
            this.popupServer = false
            this.freightData.firstFreightOrder = false
            this.submitOrder()
        },
        // 提交订单
        async submitOrder () {
            if (!this.getStatus()) {
                return false
            }

            // 第一次弹窗运费说明
            if (this.freightData.firstFreightOrder) {
                this.popupServer = true
                return
            }
            let shopArr = this.shopInfo.map((item, index) => {
                let memberAddressId = this.modelAddress[this.addressIndex].type === 1 ? this.addressInfo.id : ''
                let customerPickUp = this.modelAddress[this.addressIndex].type === 2 ? this.pickAddress[index] : {}
                let orderAdjustments = []
                let couponDiscountList = [] // 对优惠券信息进行重组
                let orderDiscountList = [] // 对活动信息进行重组
                let orderRebateList = [] // 满返折扣
                if (item.optimalCouponCompose) {
                    couponDiscountList = item.optimalCouponCompose.coupons.map(item => {
                        return {
                            amount: -item.actualDiscount,
                            sourceId: item.couponDetailId,
                            couponSkuIds: item.couponSuitSkuList,
                            couponAttachDept: item.attachDept,
                            sourceType: 0
                        }
                    })
                }
                if (item.shopActivity) {
                    let activity = item.shopActivity
                    orderDiscountList = [{
                        amount: -activity.discountAmount,
                        sourceId: activity.activityId,
                        sourceType: 1
                    }]
                }
                if (item.rebatePrice) {
                    orderRebateList = [{
                        amount: -item.rebatePrice,
                        sourceId: item.rebateDeduction.rebateWalletId,
                        sourceType: 3
                    }]
                }
                orderAdjustments = item.orderAdjustments.concat(couponDiscountList).concat(orderDiscountList).concat(orderRebateList)
                let skus = item.skus.map(item => {
                    return {
                        shoppingCartId: item.shoppingCartId,
                        skuId: item.skuId,
                        price: item.price,
                        quantity: item.quantity
                    }
                })
                return {
                    spikeId: item.spikeId,
                    groupId: item.groupId,
                    groupParticipationId: this.$route.query.groupParticipationId,
                    tyingId: item.tyingId,
                    presaleId: this.$route.query.presaleId,
                    merchantCode: item.merchantCode,
                    merchantName: item.merchantName,
                    shopName: item.shopName,
                    memberAddressId: memberAddressId,
                    customerPickUp: customerPickUp,
                    remark: item.remark,
                    skus: skus,
                    orderAdjustments: orderAdjustments,
                    orderAnnexes: item.orderAnnexes
                }
            })
            let fromData = {
                merchantCode: this.userInfo.belongMerchantCode,
                merchantName: this.userInfo.belongMerchantName,
                memberCode: this.userInfo.companyCode,
                memberName: this.userInfo.companyName,
                createBy: this.userInfo.id,
                shippingMethod: this.modelAddress[this.addressIndex].type,
                payMethod: this.payModelList[this.paymentIndex].type,
                customerName: this.userInfo.companyName + ' ' + this.userInfo.username,
                themeActivityId: this.$route.query.themeActivityId,
                shops: shopArr
            }
            Toast.loading({
                message: '提交中...',
                duration: 0,
                forbidClick: true
            })
            const { data } = await setSubmitOrder(fromData)
            Toast.clear()
            if (this.spikeId) {
                this.activityInfo()
            }
            // 是否认证
            if (this.userInfo.authenticationStatus !== 3) {
                this.popupApprove = true
                return false
            }
            // 运费是否待运营维护
            if (data.hasSpecialFreight) {
                Dialog.alert({
                    title: '提示',
                    message: '确定有待平台确认运费商品，请先联系运营人员维护',
                    confirmButtonText: '确定',
                    confirmButtonColor: '#FF7A45'
                }).then(() => {
                    localStorage.removeItem('orderNum')
                    this.$router.push({ path: '/b2b/order/orderList' })
                })
                return false
            }
            let childOrders = data.childOrders.map(item => item.id)
            if (this.payModelList[this.paymentIndex].type === 4) {
                this.$router.replace({ path: '/b2b/payment/cashier', query: { orderId: data.id, childOrders: childOrders.join(','), freightAmount: this.freightData.freight } })
            } else if (this.payModelList[this.paymentIndex].type === 1) {
                this.$router.replace({ path: '/b2b/payment/accountPay', query: { orderId: data.id, childOrders: childOrders.join(','), type: 1 } })
            } else {
                let price = this.totalPrice()
                localStorage.setItem('transferPrice', price)
                this.$router.replace({ path: '/b2b/payment/transfer' })
            }
        },
        // 埋点
        buryPoint (event) {
            this.setBuried({ event: event })
        },
        // 专题埋点
        getPoint (event, params) {
            this.setBuried({
                type: 11,
                source: 10,
                event: event,
                theme_activity_id: JSON.parse(localStorage.getItem('specialData')).id,
                theme_activity_page_title: JSON.parse(localStorage.getItem('specialData')).pageTitle,
                spuList: params ? params.spuList : [],
                skuList: params ? params.skuList : [],
                order_amount: this.totalPrice()
            })
        },
        // 特价埋点
        activityInfo () {
            this.activityParams.categoryName = 1
            this.setActivity(this.activityParams)
            localStorage.setItem('spikeData', JSON.stringify(this.activityParams))
        }
    },
    async activated () {
        if (Object.keys(this.$refs).length) {
            this.$refs.address.getAddressList()
        }
        // if (!Object.keys(this.addressInfo).length) {
        //     this.getAddressInfo()
        // }
    },
    mounted () {
        // 获取用户信息
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // 特价埋点数据
        this.activityParams = JSON.parse(localStorage.getItem('spikeData'))
        // 获取店铺信息
        this.getStopInfo()
        // 开发接口给原生调用（上传报备信息）
        window.getOEImgUrl = (tag, url) => {
            this.getOEImgUrl(tag, url)
        }
    }
}
</script>
<style lang="scss" scoped>
.order {
    height: calc(100% - 228px);
    overflow: auto;
    font-size: 32px;
    &_common {
        padding: 32px;
    }
    &_freightHeight {
        height: calc(100% - 390px);
    }
    &_height {
        height: 160px;
    }
    &_account p {
        font-size: 28px;
        display: flex;
        justify-content: space-between;
        &:first-child {
            margin-bottom: 20px;
            color: #666;
        }
    }
    &_freight {
        p {
            font-size: 28px;
            display: flex;
            justify-content: space-between;
            color: #666;
            &:first-child {
                margin-bottom: 20px;
            }
        }
        &_price {
            display: flex;
            align-items: center;
        }
        &_color {
            font-size: 26px;
            color: #999;
        }
    }
    &_model {
        background: #fff;
        display: flex;
        justify-content: space-between;
        &_left {
            color: #000;
        }
        &_right {
            color: #666;
            display: flex;
            align-items: center;
            span {
                font-size: 32px;
                color: #999;
            }
        }
    }
    &_group {
        margin: 20px 0;
        background: #fff;
        font-size: 28px;
        &_title {
            padding: 32px 32px 0;
            color: #000;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
            span {
                margin-left: 8px;
            }
        }
        &_goodList {
            padding: 0 32px;
        }
        &_foot {
            font-size: 30px;
            text-align: right;
            padding: 44px 32px;
            sub {
                font-size: 20px;
            }
        }
        /deep/ .iconfont {
            vertical-align: middle;
            font-size: 32px;
            color: #666;
        }
    }
    &_remark_textarea {
        font-size: 26px;
        color: #c7c7c7;
        text-align: right;
    }
    &_update_title,
    &_remark_title {
        margin-bottom: 32px;
        span {
            font-size: 28px;
            color: #999;
            margin-left: 12px;
        }
    }
    &_update {
        &_textarea {
            display: flex;
            flex-wrap: wrap;
            &_img {
                width: 128px;
                height: 128px;
                margin-right: 32px;
                margin-bottom: 32px;
                position: relative;
            }
            &_close {
                background-image: url("../../../assets/img/b2b/icon-delete.png");
                background-repeat: no-repeat;
                background-size: cover;
                position: absolute;
                width: 40px;
                height: 40px;
                top: -15px;
                right: -15px;
            }
        }
        /deep/ .van-icon {
            width: auto;
        }
    }
    &_footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        &_sum {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 32px;
            font-size: 30px;
            sub {
                font-size: 20px;
            }
            &_right {
                width: 208px;
                height: 64px;
                line-height: 64px;
                text-align: center;
                border-radius: 64px;
                color: #fff;
                background: #ff7a45;
            }
        }
    }
    &_arrow {
        /deep/ .van-icon {
            text-align: center;
            line-height: 46px;
            color: #666;
        }
    }
    &_f32 {
        font-size: 32px;
    }
    &_colFF7A45 {
        color: #ff7a45;
    }
    &_borderBottom {
        border-bottom: 2px solid #d1d1d6;
    }
    &_borderTop {
        border-top: 2px solid #d1d1d6;
    }
    textarea {
        font-size: 32px;
        padding: 0;
    }
}
/deep/ .van-uploader__upload,
/deep/ .van-uploader__preview-image {
    width: 128px;
    height: 128px;
}
/deep/ .van-uploader__preview-delete {
    width: 30px;
    height: 30px;
    border-radius: 0 0 0 30px;
    font-size: 28px;
}
/deep/ .van-icon__image {
    width: 100%;
    height: 100%;
}
/deep/ .van-popup {
    background: none;
}
/deep/ .van-popup--right {
    height: 100%;
    width: 100%;
}
.accountpayment{
    margin-top: 20px;
}
</style>
